import React from "react";
import girlChildImg from "../assets/girlChild4.svg"
import rocketImg from "../assets/rocket.svg"

const GetInTouchSide = () => {
  return (
    <div
      className="w-full font-Lato text-black px-[10%] lg:px-[5%] py-[10%]"
    >
      <h1 className="text-[40px] leading-[48px] font-semibold ">
        Get In{" "}
        <span style={{ color: "#D31C4F" }}>
          Touch <img src={rocketImg} className="inline h-20 w-20" alt="" />
        </span>
      </h1>
      <p style={{ color: "black", fontWeight:400, lineHeight:"20px", marginBottom: "30px", fontSize: "20px" }}>
        Need further assistance?
      </p>
      <p style={{ fontSize: "16px", fontWeight:400, marginBottom: "30px" ,color:"#4D4D4D"}}>
        Contact our support team at
        <br />
        <a
          href="mailto:support@example.com"
          style={{
            color: "#D31C4F",
            textDecoration: "none",
            fontWeight: "bold",
            fontSize:"20px",
            lineHeight:"24px"
          }}
        >
          support@example.com
        </a>
      </p>
      <p style={{ fontSize: "20px", fontWeight: "bold", color: "#4D4D4D" }}>
        or call us at
        <br />
        <span style={{ fontSize: "18px",color:"#D31C4F" }}>1-800-123-4567</span>
      </p>
      <div
        style={{
          marginTop: "30px",
        }}
      >
        <img
          src={girlChildImg}
          alt="Illustration of a girl"
          className="w-[50%] lg:w-[100%]"
          style={{
            borderRadius: "50%",
            display: "inline-block",
          }}
        />
      </div>
    </div>
  );
};

export default GetInTouchSide;
